import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@repo/design-system/components/ui/collapsible';
import { cn } from '@repo/design-system/lib/utils';
import { CheckIcon, ChevronDownIcon } from 'lucide-react';
import { useState } from 'react';

interface CertificateRequirementsProps {
  requirements: {
    title: string;
    items: string[];
  };
}

export function CertificateRequirements({
  requirements,
}: CertificateRequirementsProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className="space-y-3 pt-6"
    >
      <CollapsibleTrigger className="flex w-full items-center justify-between">
        <h4 className="font-medium text-base">{requirements.title}</h4>
        <ChevronDownIcon
          className={cn(
            'h-4 w-4 transition-transform',
            isOpen ? 'rotate-180' : ''
          )}
        />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <ul className="space-y-4">
          {requirements.items.map((item, index) => (
            <li
              key={index}
              className="grid grid-cols-[auto_1fr] items-start gap-1.5 text-sm"
            >
              <div className="mt-0.5 h-3 w-3 rounded-full bg-green-100 p-0.5 dark:bg-green-900/40">
                <CheckIcon className="h-2 w-2 text-green-600 dark:text-green-400" />
              </div>
              <div>{item}</div>
            </li>
          ))}
        </ul>
      </CollapsibleContent>
    </Collapsible>
  );
}
